<template>
  <div>
    <div class="content">
      <img src="@assets/img/duigou.png" />
      <div class="success">
        <span>提交成功</span>
      </div>
      <div class="text1">
        您的展位预定申请已提交
      </div>
      <div class="text2">
        我们将尽快通知您是否预定成功，请注意查收邮件，并保持电话畅通
      </div>
      <div class="btn" @click="back">
        <span>
          返回
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  methods: {
    back () {
      this.$router.push('/basic/mobile');//返回上一层
    },
  }
}
</script>

<style scoped lang="scss">
.content {
  padding: 2.46rem 0.3rem;
  text-align: center;
  img {
    width: 1.7rem;
    height: 1.7rem;
  }
  .success {
    margin-top: 0.33rem;
    margin-bottom: 0.33rem;
    span {
      font-size: 0.4rem;
      color: rgba(0, 161, 233, 1);
    }
  }
  .text1 {
    font-size: 0.3rem;
    color: #333;
    margin-bottom: 0.26rem;
  }
  .text2 {
    width: 5.44rem;
    margin: 0 auto;
    color: #999;
    font-size: 0.26rem;
    line-height: 0.44rem;
  }
  .btn {
    height: 0.88rem;
    background-color: rgba(0, 161, 233, 1);
    border-radius: 0.05rem;
    margin-top: 0.6rem;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      color: #fff;
      font-size: 0.36rem;
    }
  }
}
</style>
